import { noop } from "lodash";

export const useLivekitRaiseHand = () => ({
  isHandRaised: false,
  raiseHand: noop,
  lowerHand: noop,
  toggleHand: noop,
});
